import React, { useState } from 'react'
import GoBackProyectos from 'components/Proyectos/EditProyecto.jsx/GoBackProyectos'
import PageTitle from 'components/ui/Title/PageTitle'
import FormCreateProyecto from 'components/Proyectos/CreateProyecto/FormCreateProyecto'
import CreateImageProyecto from 'components/Proyectos/CreateProyecto/CreateImageProyecto'

const FormAdmin = () => {
  const [imageFile, setImageFile] = useState(null)

  return (
    <div className="container-create-proyect">
      <GoBackProyectos />
      <PageTitle>Crear Proyecto</PageTitle>

      <div className="edit-proyecto-form-config-container">
        <FormCreateProyecto imageFile={imageFile} />

        <CreateImageProyecto onImageSelect={setImageFile} />
      </div>
    </div>
  )
}

export default FormAdmin
